import React, { useState, useMemo } from 'react';
import Slider from "react-slick";

export function ProjectCardWidget({project, configuration}) {
  let projectClass = "Banner Banner__project";
  let statusClass = `status status-${project.status}`;
  let statusClass2 = `status status-in-img status-${project.status}`;
  let url = project.url;

  /*let phaseInfo = "";
  let iconphase = "";
  if (project.current_phase) {
    iconphase = `icon-${project.current_phase.phase_type}`;
    phaseInfo = (
      <div className="BannerTitu">
        <i className={iconphase} title={project.current_phase.phase_type_display}></i>
        {project.current_phase.phase_type_display}
      </div>
    )
  }*/


  return (
    <a className={projectClass} href={url}>
      <div className="BannerCont">
        <div className="BannerTitu">
          <span className={statusClass}>{project.status_label}</span>
        </div>
        <div className="BannerText">{project.title}</div>
        <div className="BannerText">{project.groups}</div>
        <div className="BannerFooter">
          <div className="BannerMore">
            <i className="icon-profiles"></i>
            <span title={configuration.translations.participantes}>
              {project.participants} / {project.capacity}
            </span>
            <br />
          </div>
          <div className="Cipa">
            {configuration.translations.takePart}
            <i className="icon-arrow-small"></i>
          </div>
        </div>
      </div>
      <div className="imgBanner">
        <span className={statusClass2}>{project.status_label}</span>
        <img src={project.list_image} alt={project.name} />
      </div>
    </a>
  );
}
